import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";

let supabaseClient: SupabaseClient | null = null;
let activeUrl: string | null = null;
let activeKey: string | null = null;

/**
 * Point the singleton at a resolved workspace (runtime config path). Called
 * by the App bootstrap BEFORE anything asks for the client. Idempotent per
 * page load; the env-var path below stays as the fallback.
 */
export const initSupabaseClient = (url: string, publishableKey: string) => {
  activeUrl = url;
  activeKey = publishableKey;
  supabaseClient = createClient(url, publishableKey);
  return supabaseClient;
};

/** The workspace's Supabase URL + publishable key (runtime or env). */
export const getSupabaseConfig = () => {
  const url = activeUrl ?? import.meta.env.VITE_SUPABASE_URL;
  const key = activeKey ?? import.meta.env.VITE_SB_PUBLISHABLE_KEY;
  if (!url || !key) {
    throw new Error(
      "Supabase is not configured: the workspace bootstrap has not run and no VITE_SUPABASE_URL/VITE_SB_PUBLISHABLE_KEY are set.",
    );
  }
  return { url, key };
};

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    const { url, key } = getSupabaseConfig();
    supabaseClient = createClient(url, key);
  }
  return supabaseClient;
};
